import { ContactTaskRepeatConstants, UserTaskTypeConstants } from "finhelper";
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';

import { CLIENT_TYPE, CONTACT_TYPE } from '#app/components/relations/constants/taskEntityTypes';


export const useTaskForm = (
    form: any,
    setModalVisible: (visible: boolean) => void,
    setForm: React.Dispatch<React.SetStateAction<any>>
) => {
    const initDateRef = useRef(moment().startOf('hour'));

    const [type, setType] = useState(CLIENT_TYPE);
    const [search, setSearch] = useState('');
    const [showContactSelect, setShowContactSelect] = useState(false);
    const [loading, setLoading] = useState(false);
    const [id, setId] = useState(null);
    const [typeId, setTypeId] = useState(UserTaskTypeConstants.CALLS);
    const [comment, setComment] = useState('');
    const [contactId, setContactId] = useState('');
    const [startDate, setStartDate] = useState(() => initDateRef.current.toDate());
    const [endDate, setEndDate] = useState(() => initDateRef.current.clone().add(30, 'minutes').toDate());
    const [repeatId, setRepeatId] = useState(ContactTaskRepeatConstants.REPEAT_NONE);
    const [contacts, setContacts] = useState([]);
    const [formErrors, changeFormErrors] = useState({});

    const formRef = useRef(form);
    formRef.current = form;
    const formKey = form
        ? [
            form.id,
            form.user_id,
            form.contact_id,
            form.type,
            form.type_id,
            form.comment,
            form.start_at_datetime,
            form.end_at_datetime,
            form.repeat_id,
        ].join('|')
        : '';

    useEffect(() => {
        const currentForm = formRef.current;
        if (!currentForm) {
            return;
        }
        const initDate = initDateRef.current;

        setId(currentForm.id || null);

        if (currentForm.user_id) {
            setContactId(currentForm.user_id + '-user');
            setType(currentForm.type || CLIENT_TYPE);
        } else if (currentForm.contact_id) {
            setContactId(currentForm.contact_id + '-contact');
            setType(currentForm.type || CONTACT_TYPE);
        }

        setTypeId(currentForm.type_id || UserTaskTypeConstants.CALLS);
        setComment(currentForm.comment || '');
        setStartDate(
            moment(currentForm.start_at_datetime, 'DD.MM.YYYY HH:mm:ss').toDate() || initDate.toDate()
        );
        setEndDate(
            moment(currentForm.end_at_datetime, 'DD.MM.YYYY HH:mm:ss').toDate()
            || initDate.clone().add(30, 'minutes').toDate()
        );
        setRepeatId(currentForm.repeat_id || ContactTaskRepeatConstants.REPEAT_NONE);
    }, [formKey]);

    const clearForm = () => {
        let startDate, endDate;
        if (moment().minutes() < 30) {
            startDate = moment().startOf('hour');
            endDate = moment().minutes(30);
        } else {
            startDate = moment().minutes(30);
            endDate = moment().startOf('hour').add(1, 'hour');
        }
        setId(null);
        setContactId('');
        setTypeId(UserTaskTypeConstants.CALLS);
        setComment('');
        setStartDate(startDate.toDate());
        setEndDate(endDate.toDate());
        setRepeatId(ContactTaskRepeatConstants.REPEAT_NONE);
    };

    const closeForm = () => {
        clearForm();
        changeFormErrors({});
        setModalVisible(false);
        setForm(null);
        setType(1);
    };

    const hasError = (fieldName: string) => {
        if (formErrors && formErrors[fieldName] && formErrors[fieldName].length > 0) {
            return true;
        }
    };

    const getError = (fieldName: string) => {
        if (formErrors && typeof formErrors[fieldName] !== 'undefined' && formErrors[fieldName].length > 0) {
            return formErrors[fieldName][0];
        }
    };

    return {
        id, setId,
        type, setType,
        search, setSearch,
        showContactSelect, setShowContactSelect,
        loading, setLoading,
        typeId, setTypeId,
        comment, setComment,
        contactId, setContactId,
        startDate, setStartDate,
        endDate, setEndDate,
        repeatId, setRepeatId,
        contacts, setContacts,
        formErrors, changeFormErrors,
        hasError, getError,
        closeForm
    };
};